/**
 * Centralized PostHog analytics event names.
 *
 * Conventions:
 *   - Event names are Title Case strings (e.g. "Task Created").
 *   - Property keys passed alongside these events MUST be snake_case.
 *   - Reference these constants everywhere instead of hard-coding strings.
 */

export const POSTHOG_EVENTS = Object.freeze({
  // ── Authentication ────────────────────────────────────────────────────────
  USER_LOGGED_IN: "User Logged In",
  USER_LOGGED_OUT: "User Logged Out",
  EMAIL_LOGIN_ATTEMPT: "Email Login Attempt",
  EMAIL_LOGIN_FAILED: "Email Login Failed",
  LOGIN_ATTEMPT: "Login Attempt",
  LOGIN_SUCCESS: "Login Success",
  LOGIN_FAILED: "Login Failed",
  LOGIN_VALIDATION_ERROR: "Login Validation Error",
  GOOGLE_AUTH_ATTEMPT: "Google Auth Attempt",
  GOOGLE_AUTH_FAILED: "Google Auth Failed",
  USER_SIGNUP_ATTEMPT: "User Signup Attempt",
  USER_SIGNUP_SUCCESS: "User Signup Success",
  USER_SIGNUP_FAILED: "User Signup Failed",

  // ── Password / OTP ────────────────────────────────────────────────────────
  PASSWORD_RESET_REQUESTED: "Password Reset Requested",
  PASSWORD_RESET_REQUEST_FAILED: "Password Reset Request Failed",
  PASSWORD_RESET_COMPLETED: "Password Reset Completed",
  PASSWORD_RESET_FAILED: "Password Reset Failed",
  PASSWORD_RESET_OTP_RESENT: "Password Reset OTP Resent",
  PASSWORD_VALIDATION_ERROR: "Password Validation Error",
  PASSWORD_CHANGED: "Password Changed",
  PASSWORD_CHANGE_FAILED: "Password Change Failed",
  OTP_VERIFIED: "OTP Verified",
  OTP_VERIFICATION_FAILED: "OTP Verification Failed",
  OTP_RESEND_FAILED: "OTP Resend Failed",

  // ── User / Profile ────────────────────────────────────────────────────────
  USER_CREATED: "User Created",
  USER_CREATION_FAILED: "User Creation Failed",
  PROFILE_UPDATED: "Profile Updated",
  PROFILE_UPDATE_FAILED: "Profile Update Failed",

  // ── Task lifecycle ────────────────────────────────────────────────────────
  TASK_CREATED: "Task Created",
  TASK_UPDATED: "Task Updated",
  TASK_UPDATE_FAILED: "Task Update Failed",
  TASK_DELETED: "Task Deleted",
  TASK_DELETE_FAILED: "Task Delete Failed",
  TASK_ASSIGNED: "Task Assigned",
  TASK_STATUS_CHANGED: "Task Status Changed",
  TASK_PRIORITY_CHANGED: "Priority Changed",
  TASK_START_DATE_SET: "Start Date Set",
  TASK_DUE_DATE_SET: "Due Date Set",
  TASK_TAG_ADDED: "Tag Added",
  TASK_DELEGATED: "Task Delegated",
  SUBTASK_CREATED: "Subtask Created",
  TASKS_EXPORTED: "Tasks Exported",
  TASKS_EXPORT_FAILED: "Tasks Export Failed",
  BULK_TASK_STATUS_UPDATED: "Bulk Task Status Updated",
  BULK_TASK_STATUS_UPDATE_FAILED: "Bulk Task Status Update Failed",

  // ── Attachments / Comments ────────────────────────────────────────────────
  ATTACHMENT_ADDED: "Attachment Added",
  ATTACHMENT_REMOVED: "Attachment Removed",
  ATTACHMENT_REMOVE_FAILED: "Attachment Remove Failed",
  COMMENT_ADDED: "Comment Added",
  COMMENT_DELETED: "Comment Deleted",

  // ── Bulk upload ───────────────────────────────────────────────────────────
  BULK_UPLOAD_COMPLETED: "Bulk Upload Completed",
  BULK_UPLOAD_FAILED: "Bulk Upload Failed",
  BULK_UPLOAD_TEMPLATE_DOWNLOADED: "Bulk Upload Template Downloaded",

  // ── Notifications ─────────────────────────────────────────────────────────
  NOTIFICATION_MARKED_READ: "Notification Marked Read",
  NOTIFICATION_CLEARED: "Notification Cleared",

  // ── Projects / Groups / Roles ─────────────────────────────────────────────
  PROJECT_CREATED: "Project Created",
  PROJECT_UPDATED: "Project Updated",
  PROJECT_DELETED: "Project Deleted",
  GROUP_CREATED: "Group Created",
  GROUP_UPDATED: "Group Updated",
  GROUP_DELETED: "Group Deleted",
  ROLES_ASSIGNED: "Roles Assigned",
  ROLES_ASSIGNMENT_FAILED: "Roles Assignment Failed",

  // ── Checklists ────────────────────────────────────────────────────────────
  CHECKLIST_CREATED: "Checklist Created",
  DAILY_CHECKLIST_EXECUTED: "Daily Checklist Executed",

  // ── Admin / misc ──────────────────────────────────────────────────────────
  ADMIN_QUICK_ACTION: "Admin Quick Action",
  REACT_ERROR: "React Error",
});

export default POSTHOG_EVENTS;
